import styled from '@emotion/styled'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import { theme } from 'styles/theme/hav-theme'
import { InputLabel, SelectProps } from '@mui/material'

interface SelectStyledProps extends SelectProps {
  height: number
  disabled?: boolean
}

export const FormControlStyled = styled(FormControl)`
  .MuiSelect-select {
    padding: 4px ${theme.spacing.md} !important;
  }
`

export const SelectStyled = styled(Select)<SelectStyledProps>`
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height)};

  svg {
    color: ${theme.colors.primary.main};
  }

  .MuiOutlinedInput-input {
    display: flex;
    align-items: center;
    padding: ${theme.spacing.sm} 0 ${theme.spacing.sm} ${theme.spacing.sm};

    div:first-of-type {
      justify-content: flex-start;
      gap: ${theme.spacing.sm};
    }
  }

  .Mui-disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.neutral[100]};
    -webkit-text-fill-color: ${theme.colors.neutral.mediumhover};
  }

  fieldset {
    ${({ disabled }) =>
      disabled &&
      `
        border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear} !important;
      `}
  }
`

export const LabelStyled = styled(InputLabel)`
  margin: 0;
  z-index: 0;
  cursor: inherit;
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  overflow: initial;
  position: relative;
  transform: initial;
  display: flex;
`

export const WrapLabelStyled = styled.div`
  display: flex;
`

export const ItemWrapper = styled.div`
  width: 100%;
  height: ${theme.spacing.xm};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${theme.typography.sizes.xs};
  gap: ${theme.spacing.xs};
`

export const ItemLabel = styled.span`
  padding-top: 3px;
  line-height: 100%;
`

export const SelectTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px ${theme.spacing.xs};
  height: ${theme.spacing.xm};
  background: ${theme.colors.alert.info.dark};
  border-radius: 2px;
  width: 74px;

  span {
    line-height: 100%;
    font-size: ${theme.typography.sizes['2xs']};
    -webkit-text-fill-color: ${theme.colors.neutral.white};
  }
`
